import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominaDocumentosLayoutsh2hCompletadosLayout', {
    template: template,
    controller: NominaDocumentosLayoutsh2hCompletadosLayoutComponent,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
      idLayout: '<',
      idBanco: '<',
      idCuenta: '<',
      banco: '<',
      numeroCuenta: '<',
      moneda: '<',
      onClose: '&',
      onChange: '&',
    },
  })

function NominaDocumentosLayoutsh2hCompletadosLayoutComponent(NominaDocumentosLayoutsh2hLayout) {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.cerrar = cerrar

  function $onInit() {
    $ctrl.promise = NominaDocumentosLayoutsh2hLayout.get($ctrl.idEmpresa, $ctrl.idNomina, $ctrl.idLayout)
      .then(function (response) {
        $ctrl.layout = response.data.layout
        $ctrl.data = response.data.pagos
      })
  }

  function cerrar() {
    $ctrl.onClose()
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/documentos/layoutsh2h/completados/layout/component.js